import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { FileService, PAGINATION_SIZES,StorageIconFile } from '@evc/platform';

import { BrowseTargetActions, ToastActions } from '@app/store/actions';
import type { BackendError } from '@app/types/error/backend-error.type';
import type { FileItem } from '@app/types/file-item.type';

@Injectable()
export class BrowseTargetEffects {
  readonly #actions$ = inject(Actions);
  readonly #fileService = inject(FileService);

  loadFolders$: any = createEffect((): any =>
    this.#actions$.pipe(
      ofType(BrowseTargetActions.loadFolders),
      switchMap(({ parent }: { parent: FileItem }) =>
        this.#fileService
          .browse$({
            parentId: parent?.id,
            onlyFolders: true,
            pageSize: PAGINATION_SIZES.DIRECTORIES,
          })
          .pipe(
            map(({ items }: { items: StorageIconFile[] }) =>
              BrowseTargetActions.loadFoldersSuccess({ list: items }),
            ),
            catchError((error: BackendError) => of(BrowseTargetActions.loadFoldersFail({ error }))),
          ),
      ),
    ),
  );

  loadFoldersFail$: any = createEffect((): any =>
    this.#actions$.pipe(
      ofType(BrowseTargetActions.loadFoldersFail),
      map((action: { error: BackendError }) => action.error),
      switchMap(({ errorType }: BackendError) => [
        ToastActions.addToastError({
          message: errorType ? `file.error.${errorType}` : 'toast.error',
        }),
      ]),
    ),
  );
}
